import { ActivatedRoute } from '@angular/router';
import { BookServiceService } from "src/app/services/book-service.service";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-news",
  templateUrl: "./news.component.html",
  styleUrls: ["./news.component.scss"]
})
export class NewsComponent implements OnInit {
  constructor(private ser: BookServiceService , private router : ActivatedRoute) {}
  news: any;
    ngOnInit() {
    // get Posts 
    this.ser.news().subscribe(data => {
      this.news = data.map(el => {
        return {
          id: el.payload.doc.id,
          ...el.payload.doc.data()
        };
      });

      /// get one post 

    });


  }

}
